module.exports = __webpack_public_path__ + "img/store_title.25bfed9d.jpg";